import ActShow from "../components/act/Show";

export default [
  { name: 'Act', path: '/act', component: ActShow,  }
]
